export function Terms() {
  return (
    <div className="mx-auto flex w-full max-w-[420px] flex-col gap-4 px-5 py-6 text-sm text-ivory/85">
      <h1 className="heading-display text-3xl">Пользовательское соглашение</h1>
      <p className="text-xs text-ivory/55">Действует с 27 апреля 2026 г.</p>

      <Section title="О чём это">
        <p>
          durakapp — приложение для игры в подкидного дурака с реальными соперниками. Запуская
          партию, вы соглашаетесь с этими правилами. Если что-то не подходит — просто не играйте.
        </p>
      </Section>

      <Section title="Игра — навык, не азарт">
        <p>
          Подкидной дурак — игра на умение. Победитель определяется ходами игроков, а не
          случайностью: раздача карт фиксируется детерминированным сидом, а вся партия
          воспроизводится по записи ходов. Сервис не предоставляет услуги азартных игр.
        </p>
      </Section>

      <Section title="Ставки и фишки">
        <ul className="ml-4 list-disc space-y-1">
          <li>
            Внутренняя валюта игры — <strong>фишки</strong>. Это не Telegram Stars и не
            фиатная валюта; фишки существуют только внутри durakapp.
          </li>
          <li>
            Доступны столы без ставок и со ставками <strong>10 / 50 / 100 / 500 фишек</strong>.
          </li>
          <li>
            Ставка списывается с внутреннего баланса при входе в очередь и возвращается, если
            матч не состоялся.
          </li>
          <li>
            Платформа удерживает <strong>10% комиссию</strong> с банка. Остаток делится поровну
            между не-проигравшими. Ничья — возврат ставки каждому.
          </li>
          <li>
            Купить фишки можно за Telegram Stars, USDT, TON, BTC, ETH (через @CryptoBot)
            или напрямую TON-переводом. Вывод доступен через @CryptoBot и прямой TON.
            Подробнее в разделе «Баланс и фишки» в меню.
          </li>
        </ul>
      </Section>

      <Section title="Дисконнекты и таймауты">
        <ul className="ml-4 list-disc space-y-1">
          <li>На ход даётся 30 секунд. По таймауту защитник «забирает», атакующий «бито».</li>
          <li>
            При отключении даётся 30 секунд на reconnect. Если игрок не вернулся — засчитывается
            поражение, банк делится между остальными.
          </li>
          <li>
            Намеренный disconnect для уклонения от поражения = поражение. Это не баг.
          </li>
        </ul>
      </Section>

      <Section title="Запрещено">
        <ul className="ml-4 list-disc space-y-1">
          <li>Боты, скрипты, эмуляция действий, любой автокликер.</li>
          <li>Передача аккаунта и совместная игра с целью договорного слива.</li>
          <li>Эксплуатация багов вместо отчёта о них в поддержку.</li>
        </ul>
        <p>
          Нарушение → блокировка аккаунта и удержание спорных средств до выяснения. Серьёзные
          случаи передаём в Telegram.
        </p>
      </Section>

      <Section title="Возвраты">
        <p>
          Если матч не состоялся по технической причине — ставка возвращается автоматически.
          В остальных спорных случаях напишите в поддержку{' '}
          <a href="https://t.me/durakapp_game_bot" className="text-gold underline">
            @durakapp_game_bot
          </a>{' '}
          в течение 7 дней с момента события. Решение принимается на основе детерминированной
          записи партии и журнала транзакций.
        </p>
      </Section>

      <Section title="Возрастной ценз">
        <p>
          Сервис рассчитан на пользователей старше 18 лет. Запуская платную партию, вы
          подтверждаете свой возраст и право распоряжаться используемыми средствами.
        </p>
      </Section>

      <Section title="Ограничение ответственности">
        <p>
          Сервис предоставляется «как есть». Мы не гарантируем непрерывную работу и не несём
          ответственность за упущенную выгоду. Все известные нам инциденты публикуются в нашем
          канале поддержки.
        </p>
      </Section>

      <Section title="Изменения">
        <p>
          Эти правила могут меняться. Существенные изменения мы публикуем в боте и на этой
          странице за 7 дней до вступления в силу.
        </p>
      </Section>

      <Section title="Контакт">
        <p>
          По любым вопросам:{' '}
          <a href="https://t.me/durakapp_game_bot" className="text-gold underline">
            @durakapp_game_bot
          </a>
          .
        </p>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="heading-display text-xl text-gold">{title}</h2>
      {children}
    </section>
  );
}
